"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _styles = require("@material-ui/core/styles");
var _Dialog = _interopRequireDefault(require("@material-ui/core/Dialog"));
var _DialogTitle = _interopRequireDefault(require("@material-ui/core/DialogTitle"));
var _DialogActions = _interopRequireDefault(require("@material-ui/core/DialogActions"));
var _DialogContent = _interopRequireDefault(require("@material-ui/core/DialogContent"));
var _IconButton = _interopRequireDefault(require("@material-ui/core/IconButton"));
var _Close = _interopRequireDefault(require("@material-ui/icons/Close"));
var _SttHeading = _interopRequireDefault(require("./SttTypography/SttHeading"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _excluded = ["outModalClose", "title", "iconClose", "children", "footer", "open", "contentDividers", "headerExtra"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    paper: {
      backgroundColor: theme.palette.common.white,
      borderRadius: theme.spacing(1),
      boxShadow: theme.shadows[8]
    },
    heading: {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.common.white,
      padding: theme.spacing(2, 3),
      position: 'relative',
      borderBottom: "1px solid ".concat(theme.palette.background.border)
    },
    titleText: {
      color: theme.palette.common.white,
      fontWeight: theme.typography.fontWeightBold
    },
    content: {
      backgroundColor: theme.palette.common.white,
      padding: theme.spacing(3)
    },
    contentDivided: {
      '& > *': {
        borderBottom: "1px solid ".concat(theme.palette.background.border),
        padding: theme.spacing(2, 0)
      },
      '& > *:last-child': {
        borderBottom: 'none'
      }
    },
    footer: {
      position: 'relative',
      paddingLeft: theme.spacing(3),
      paddingRight: theme.spacing(3),
      backgroundColor: theme.palette.common.white,
      paddingTop: theme.spacing(2),
      paddingBottom: theme.spacing(2),
      display: 'flex',
      justifyContent: 'flex-end',
      gap: theme.spacing(1.5),
      '&::before': {
        content: '""',
        position: 'absolute',
        top: 0,
        left: theme.spacing(3),
        right: theme.spacing(3),
        height: 1,
        backgroundColor: theme.palette.background.border
      },
      '& .stt-cancel, & [data-role="cancel"]': {
        color: theme.palette.error.main
      },
      '& .stt-cancel.MuiButton-contained, & [data-role="cancel"].MuiButton-contained': {
        backgroundColor: theme.palette.error.main,
        color: theme.palette.common.white,
        '&:hover': {
          backgroundColor: (0, _styles.darken)(theme.palette.error.main, 0.08)
        }
      },
      '& .stt-cancel.MuiButton-outlined, & [data-role="cancel"].MuiButton-outlined': {
        borderColor: theme.palette.error.main,
        color: theme.palette.error.main,
        '&:hover': {
          borderColor: (0, _styles.darken)(theme.palette.error.main, 0.08)
        }
      }
    },
    closeButton: {
      position: 'absolute',
      right: theme.spacing(1.5),
      top: theme.spacing(1.5),
      color: theme.palette.common.white
    }
  };
});
SttModal.propTypes = {
  title: _propTypes["default"].string,
  children: _propTypes["default"].node,
  footer: _propTypes["default"].node,
  outModalClose: _propTypes["default"].func,
  iconClose: _propTypes["default"].func,
  open: _propTypes["default"].bool.isRequired,
  contentDividers: _propTypes["default"].bool,
  headerExtra: _propTypes["default"].node
};
SttModal.defaultProps = {
  open: false,
  contentDividers: false
};
function SttModal(props) {
  var classes = useStyles();
  var outModalClose = props.outModalClose,
    title = props.title,
    iconClose = props.iconClose,
    children = props.children,
    footer = props.footer,
    open = props.open,
    contentDividers = props.contentDividers,
    headerExtra = props.headerExtra,
    other = _objectWithoutProperties(props, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_Dialog["default"], _extends({
    open: open,
    onClose: outModalClose,
    classes: {
      paper: classes.paper
    }
  }, other), /*#__PURE__*/_react["default"].createElement(_DialogTitle["default"], {
    className: classes.heading,
    disableTypography: true
  }, /*#__PURE__*/_react["default"].createElement(_SttHeading["default"], {
    variant: "h2",
    color: "inherit",
    className: classes.titleText
  }, title), iconClose && /*#__PURE__*/_react["default"].createElement(_IconButton["default"], {
    "aria-label": "close",
    className: classes.closeButton,
    onClick: iconClose
  }, /*#__PURE__*/_react["default"].createElement(_Close["default"], null)), headerExtra && /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      marginTop: 16
    }
  }, headerExtra)), /*#__PURE__*/_react["default"].createElement(_DialogContent["default"], {
    className: "".concat(classes.content, " ").concat(contentDividers ? classes.contentDivided : '')
  }, children), footer && /*#__PURE__*/_react["default"].createElement(_DialogActions["default"], {
    className: classes.footer
  }, footer));
}
var _default = SttModal;
exports["default"] = _default;